import React from "react";
import { Container } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import pdf from "../../Assets/ForPortfolio.pdf";
import resumePageOne from "../../Assets/resume-page-1.png";
import resumePageTwo from "../../Assets/resume-page-2.png";
import { AiOutlineDownload, AiOutlineEye } from "react-icons/ai";

function ResumeActions() {
  return (
    <div className="resume-actions">
      <Button
        variant="primary"
        href={pdf}
        target="_blank"
        rel="noreferrer"
      >
        <AiOutlineEye aria-hidden="true" />
        &nbsp;Open PDF
      </Button>
      <Button
        variant="primary"
        href={pdf}
        download="Abhinav-Rathee-Resume.pdf"
      >
        <AiOutlineDownload aria-hidden="true" />
        &nbsp;Download CV
      </Button>
    </div>
  );
}

function ResumeNew() {
  return (
    <Container fluid className="resume-section">
      <Particle />
      <header className="resume-header">
        <p className="resume-kicker">Curriculum Vitae</p>
        <h1>My Resume</h1>
        <p>View both pages below, open the original PDF, or download a copy.</p>
        <ResumeActions />
      </header>

      <div className="resume-document" aria-label="Abhinav Rathee resume">
        <figure className="resume-page">
          <img
            className="resume-page-image"
            src={resumePageOne}
            alt="Abhinav Rathee resume, page 1 of 2"
            loading="eager"
            decoding="async"
          />
        </figure>
        <figure className="resume-page">
          <img
            className="resume-page-image"
            src={resumePageTwo}
            alt="Abhinav Rathee resume, page 2 of 2"
            loading="lazy"
            decoding="async"
          />
        </figure>
      </div>

      <ResumeActions />
    </Container>
  );
}

export default ResumeNew;
